export default __webpack_public_path__ + "static/media/mens.6ad225e2.svg";